import React from 'react';
import {Button} from 'reactstrap';
import {useHistory} from 'react-router';

const NoEntitiesPage = () => {
    let history = useHistory();

    const redirectToCreateEntities = () => {
        history.push('/add-entity')
    }
    return (
        <div className="mt-3 w-100 h-100 d-flex flex-column align-items-start" style={{padding: '0 30px'}}>
            <h1 className="mt-3 mb-3">Saved Searches</h1>
            At least one entity must be created in order to save and customize searches.
            <Button className=" mt-3 calltoaction-button" onClick={redirectToCreateEntities}>
                Create an Entity
            </Button>
        </div>
    );
};

export default NoEntitiesPage;
